export default __webpack_public_path__ + "alert.342a7345ccf30a68.svg";